<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="cogs"/>
          {{ $t('setting') }}
        </h1>
      </div>
    </div>
    <invoice-setup-list/>
  </main>
</template>

<script>
import InvoiceSetupList from "@/views/vat-invoice/InvoiceSetupList.vue";

export default {
  components: {InvoiceSetupList},
  data() {
    return {}
  },
  i18n: {
    messages: {
      en: {
        setting: 'Setting'
      },
      vi: {
        setting: 'Cài đặt'
      }
    }
  },
}
</script>